presenterChatClient.directive('presenterChatClient', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'presenter_chat_client/templates/' + helperService.getRedesignPathPrefix() + 'presenterChatClient.html'
            ),
            link: function (scope, element, attrs, ngCtrl) {}
        };
    }
]);
